export default {
  
  updateQueryStringParameter(uri, key, value) {

    var re = new RegExp("([?|&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  },
  
  getURLParameter(paramName) {
   // Parse the URL and get the parameters
   let urlParams = new URLSearchParams(window.location.search);

   // Get the specific parameter by its name and return its value
   return urlParams.get(paramName);
 },
 
 sendAppMessage(params) {
	 
	console.log('app/helper/sendAppMessage');
	 
   // Flutter ios & Android | flutter_webview package
   if(typeof Flutter != "undefined") {
     Flutter.postMessage(JSON.stringify(params));
   }	
   
   // Flutter ios & Android | inappwebview package
   if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
     window.flutter_inappwebview.callHandler('Flutter', JSON.stringify(params));
   } else if(window.flutter_inappwebview && window.flutter_inappwebview._callHandler) {
     window.flutter_inappwebview._callHandler('Flutter', setTimeout(function(){}), JSON.stringify([params]));
   }   
 },

 // random number
 getRandInteger(min, max) {
   if(!min) min = 1;
   if(!max) max = 1000;
   if(max) max++;
   return Math.floor(Math.random() * (max - min) ) + min;
 }, 
 
 // Confirm modal
 // params: object (title, onConfirm, onCancel)
 confirmModal(args) {
 
    // Params
    const title = args.title ?? 'Bevestigen';
    var onConfirm = args.onConfirm || function() {};
    var onCancel = args.onCancel || function() {};   
    
    UIkit.modal.confirm(title).then(function() {
      // Confirmed
      if(onConfirm) {
        onConfirm();
      }
    }, function () {
      // Rejected
      if(onCancel) {
        onCancel();
      }
    });
 },
 
 // Login register modal
 // Shows a web modal for the website, triggers native login modal on app
 loginRegisterModal(_params) {
	 
		var params = _params || {};

		if(params.isApp == true) {
			this.sendAppMessage({
				action: "toggleLogin"
			});
		} else { 
			UIkit.modal(document.getElementById('login-register-modal')).show();
		}
  },
 
 // Validate url
	isValidUrl(urlString) {
		 var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
				'(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
	  return !!urlPattern.test(urlString);
  } 
 
}